import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TermSheetPromoterUpdateModalUI from './TermSheetPromoterUpdateModalUI.js'

class TermSheetPromoterUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      sharePledgedPercent: '',
      sharePledgedPercentError: null,
      guarantor: 'false',
      guarantorError: null,
    }
  }

  render() {
    const booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <TermSheetPromoterUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        name={this.props.selectedUser && this.props.selectedUser.name}
        sharePledgedPercent={this.state.sharePledgedPercent}
        onSharePledgedPercentChange={(event) => { this.setState({ sharePledgedPercent: event.target.value }) }}
        sharePledgedPercentError={this.state.sharePledgedPercentError}
        setSharePledgedPercentError={(error) => { this.setState({ sharePledgedPercentError: error }) }}
        guarantor={this.state.guarantor}
        onGuarantorChange={(event) => { this.setState({ guarantor: event.target.value }) }}
        guarantorError={this.state.guarantorError}
        booleanList={booleanList}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentWillReceiveProps(props) {
    if (props.selectedUser) {
      this.setState({
        sharePledgedPercent: props.selectedUser.sharePledgedPercent || '',
        guarantor: '' + props.selectedUser.guarantor,
        submitted: false,
        errorList: null,
      })
    }
  }

  onSubmit = () => {
    if (this.state.submitted) return

    const user = this.props.selectedUser || {}
    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet/users/${user.userId}`,
      this.onSubmitCallback, {
        sharePledgedPercent: this.state.sharePledgedPercent,
        guarantor: this.state.guarantor,
      }
    )
  }

  onSubmitCallback = (response) => {
    const errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default TermSheetPromoterUpdateModalSF
